import { useEffect, useState } from "react";
import api from "../../lib/api";
import { currency, fmtDate } from "../../lib/status";
import { toast } from "sonner";

export default function AdminPayouts() {
    const [payouts, setPayouts] = useState([]);
    const [techs, setTechs] = useState({});

    const load = async () => {
        const { data: p } = await api.get("/payouts");
        setPayouts(p);
        const { data: t } = await api.get("/technicians");
        setTechs(Object.fromEntries(t.map((x) => [x.id, x])));
    };
    useEffect(() => {
        load();
    }, []);

    const calculate = async () => {
        try {
            const { data } = await api.post("/payouts/calculate");
            toast.success(`Created ${data.count} payouts`);
            load();
        } catch (e) {
            toast.error("Failed");
        }
    };

    const markPaid = async (id) => {
        try {
            await api.post(`/payouts/${id}/mark-paid`);
            toast.success("Marked paid");
            load();
        } catch (e) {
            toast.error("Failed");
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex items-end justify-between">
                <div>
                    <div className="lx-label text-[#D4AF37] mb-2">Finance</div>
                    <h1 className="font-serif text-4xl text-white">Technician payouts</h1>
                </div>
                <button
                    onClick={calculate}
                    data-testid="payout-calculate-btn"
                    className="lx-btn-gold px-5 py-2.5"
                >
                    Calculate now
                </button>
            </div>
            <div className="lx-card-dark overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="border-b border-[#2B1438] text-white/60 text-left">
                        <tr>
                            <th className="p-4 lx-label">Technician</th>
                            <th className="p-4 lx-label">Period</th>
                            <th className="p-4 lx-label">Jobs</th>
                            <th className="p-4 lx-label text-right">Gross</th>
                            <th className="p-4 lx-label text-right">Commission</th>
                            <th className="p-4 lx-label text-right">Net</th>
                            <th className="p-4 lx-label">PG Books</th>
                            <th className="p-4 lx-label">Status</th>
                            <th className="p-4" />
                        </tr>
                    </thead>
                    <tbody>
                        {payouts.map((p) => (
                            <tr
                                key={p.id}
                                className="border-b border-[#2B1438]"
                                data-testid={`payout-row-${p.id}`}
                            >
                                <td className="p-4 text-white">
                                    {techs[p.technician_id]?.name || p.technician_id}
                                </td>
                                <td className="p-4 text-white/60 text-xs">
                                    {fmtDate(p.period_start, { hour: undefined })}
                                </td>
                                <td className="p-4 text-white/80">{p.booking_ids?.length}</td>
                                <td className="p-4 text-right text-white/80">
                                    {currency(p.gross_amount, p.currency)}
                                </td>
                                <td className="p-4 text-right text-white/60">
                                    {currency(p.commission, p.currency)}
                                </td>
                                <td className="p-4 text-right text-[#D4AF37] font-serif">
                                    {currency(p.net_amount, p.currency)}
                                </td>
                                <td className="p-4 text-xs">
                                    {p.pg_books_synced ? (
                                        <span className="text-[#34C759]">✓ Synced</span>
                                    ) : (
                                        <span className="text-[#FF9500]">Pending</span>
                                    )}
                                </td>
                                <td className="p-4">
                                    <span
                                        className="text-[10px] uppercase tracking-wider px-2 py-1 border"
                                        style={{
                                            color: p.status === "paid" ? "#34C759" : "#FF9500",
                                            borderColor: p.status === "paid" ? "#34C75940" : "#FF950040",
                                        }}
                                    >
                                        {p.status}
                                    </span>
                                </td>
                                <td className="p-4">
                                    {p.status === "pending" && (
                                        <button
                                            onClick={() => markPaid(p.id)}
                                            data-testid={`payout-mark-paid-${p.id}`}
                                            className="text-xs text-[#D4AF37] hover:underline"
                                        >
                                            Mark paid
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {payouts.length === 0 && (
                    <div className="p-12 text-center text-white/60">
                        No payouts yet. Click "Calculate now".
                    </div>
                )}
            </div>
        </div>
    );
}
